if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      //this.form.querySelector('[name=id]').disabled = false;
      this.variantIdInput.disabled = false;
      this.variantIdInput.addEventListener('change', this.resetErrorState.bind(this));
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      if (document.querySelector('cart-drawer')) {
        if(this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    connectedCallback() {
      queueMicrotask(() => {
        const card = this.closest('[data-sdf-product-card]');
        if (card && this.isConnected) this.initializeSdfCard(card);
      });
    }

    initializeSdfCard(card) {
      if (this.sdfCard === card) return;
      const variantsNode = card.querySelector('[data-sdf-variants]');
      const optionSelects = Array.from(card.querySelectorAll('[data-sdf-option]'))
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
      const variantInput = card.querySelector('[data-sdf-variant-id]');
      const addButton = card.querySelector('[data-sdf-add]');
      const addLabel = card.querySelector('[data-sdf-add-label]');
      const price = card.querySelector('[data-sdf-price]');
      const badge = card.querySelector('[data-sdf-badge]');
      const primaryImage = card.querySelector('.sdf-product-card__image:not(.sdf-product-card__image--secondary)');
      const links = card.querySelectorAll('[data-sdf-product-link]');
      const productUrl = card.dataset.productUrl;
      const limited = card.dataset.limited === 'true';

      if (!variantsNode || !variantInput || !addButton || !addLabel || !price || !badge) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsNode.textContent);
      } catch (error) {
        if (addButton) addButton.disabled = true;
        return;
      }

      this.sdfCard = card;
      card.dataset.sdfReady = 'true';

      const renderVariant = (variant) => {
        if (!variant) {
          variantInput.value = '';
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          addButton.disabled = true;
          const missingSize = optionSelects.some((select) => select.hasAttribute('data-sdf-required-option') && !select.value);
          addLabel.textContent = missingSize ? card.dataset.chooseSize : 'Unavailable';
          return;
        }

        variantInput.value = String(variant.id);
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? 'Add to loot bag' : 'Sold out';

        price.replaceChildren();
        if (variant.onSale && variant.compareAtPrice) {
          const comparePrice = document.createElement('s');
          comparePrice.textContent = variant.compareAtPrice;
          price.append(comparePrice);
        }
        price.append(document.createTextNode(variant.price));

        if (!variant.available) {
          badge.hidden = false;
          badge.classList.remove('hidden');
          badge.dataset.kind = 'sold-out';
          badge.textContent = 'Sold out';
        } else if (variant.onSale) {
          badge.hidden = false;
          badge.classList.remove('hidden');
          badge.dataset.kind = 'sale';
          badge.textContent = 'Sale';
        } else if (limited) {
          badge.hidden = false;
          badge.classList.remove('hidden');
          badge.dataset.kind = 'limited';
          badge.textContent = 'Limited';
        } else {
          badge.hidden = true;
          badge.classList.add('hidden');
          badge.textContent = '';
        }

        links.forEach((link) => {
          const url = new URL(productUrl, window.location.origin);
          url.searchParams.set('variant', variant.id);
          link.href = url.pathname + url.search;
        });

        if (primaryImage && variant.image) {
          primaryImage.src = variant.image;
          primaryImage.srcset = '';
          if (variant.imageAlt) primaryImage.alt = variant.imageAlt;
        }
      };

      const updateVariant = () => {
        const selectedOptions = optionSelects.map((select) => select.value);
        const variant = variants.find((candidate) =>
          candidate.options.length === selectedOptions.length &&
          candidate.options.every((value, index) => value === selectedOptions[index])
        );
        renderVariant(variant);
      };

      optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
      if (optionSelects.length) updateVariant();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.resetErrorState();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      let itemAdded = false;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          itemAdded = true;
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), cartData: response});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch(() => {
          this.error = true;
          if (itemAdded && !this.dataset.confirmationError) {
            window.location = window.routes.cart_url;
            return;
          }
          this.handleErrorMessage(itemAdded ? this.dataset.confirmationError : this.dataset.addError || window.cartStrings.error);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (itemAdded && this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    resetErrorState() {
      this.error = false;
      this.handleErrorMessage();
      this.submitButtonText?.classList.remove('hidden');
      this.submitButton.querySelector('.sold-out-message')?.classList.add('hidden');
      if (!this.submitButton.classList.contains('loading')) this.submitButton.removeAttribute('aria-disabled');
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  });
}
